export default defineNuxtRouteMiddleware((to, from) => {
  console.log("HERO MIDDLEWARE: Running")
  if (import.meta.server) {
    console.log("THIS IS THE HERO MIDDLEWARE: server")
  }

  if (import.meta.client) {
    console.log("THIS IS THE HERO MIDDLEWARE: client")
  }
})